export default {"src":"/_next/static/media/carret-up.843897fc.svg","height":8,"width":14,"blurWidth":0,"blurHeight":0};